//npm install leaflet@1.7.1 --legacy-peer-deps
import * as L from 'leaflet';
import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { first } from 'rxjs/operators';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { Table } from 'primeng/table';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MarkerService } from 'src/app/utils/marker.service';
import { ShapeService } from 'src/app/utils/shape.service';

const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
const iconDefault = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
L.Marker.prototype.options.icon = iconDefault;

@Component({
  selector: 'app-local-national-order-leaflet',
  templateUrl: './local-national-order-leaflet.component.html',
  styleUrls: ['./local-national-order-leaflet.component.scss'],
  providers: [MessageService, ConfirmationService, MarkerService, ShapeService],
})

export class LocalNationalOrderLeafletComponent implements OnInit, AfterViewInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;

  /** LABELS */
  lbl_go_Back: string = "back_";
  lbl_language: string = "language_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_participants: string = "participants_";
  lbl_new_record: string = "new_record_";
  lbl_name: string = "name_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_email: string = "email_";
  lbl_gender: string = "gender_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_";
  lbl_search: string = "search_";
  lbl_particp15s: string = "10a15a_particip_";
  lbl_participants_12: string = "participants_";
  lbl_participants_1st: string = "participants_2nd_sesion_";
  lbl_future_guide: string = "future_guide_";
  lbl_partic_partner: string = "partic_partners_";
  lbl_no_sent: string = "no_sent_";
  lbl_age: string = "age_";
  lbl_school_prep_guides: string = "school_prep_guides_";
  lbl_comments: string = "comments_";
  lbl_date: string = "date_";
  lbl_save: string = "save_";
  lbl_guide_id: string = "guide_id_";
  lbl_certificate: string = "certificate_";
  lbl_change_Status_Guide_or_Comment: string = "change_Status_Guide_or_Comment";
  lbl_coordination: string = "coordination_";
  lbl_guideId: string = "guideId_";
  lbl_status: string = "status_";
  lbl_leaving_reason: string = "leaving_reason_";
  lbl_select: string = "select_";
  lbl_send: string = "send_";
  lbl_guide: string = "guide_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_updated_data: string = "updated_data_";
  lbl_delete_record: string = "delete_record_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_total: string = "total_";
  lbl_vendor: string = "vendor_";
  lbl_OR_vendor_quote: string = "OR_vendor_quote_";
  lbl_new: string = "new_";
  lbl_orders_request: string = "orders_request_";
  lbl_req_Date: string = "req_Date_";
  lbl_currency: string = "currency_";

  /** COMPONENT TABLE */
  @ViewChild('dt') table: Table;
  data: Record<string, any>[];
  cols: any[];
  endPointFindPurchordhByStoreId = "findPurchordhByStoreId";
  colsGlobal = ['ordH.orderId', 'stsDesc',];
  colsFilter = [
    { name: 'Identificador', value: 'ordH.orderId' },
    { name: 'Tipo', value: 'storeDesc' },
  ];

  rowsPerPage: number = 8; // Cambia esto según tus necesidades


  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** SEARCH FORM */
  dataForm: FormGroup;
  languagesLst: { label: string; value: string; }[];

  /** MAPS */
  points: any;
  shape: any;

  /**
   * This is a constructor function that initializes various services and variables used in the
   * component.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user.
   * @param {PurchOrdSupLstService} purchOrdSupLstServiceTest - This parameter is an instance of the
   * PurchOrdSupLstService class. It is used to perform operations related to the purchase order
   * supplier list.
   * @param {ConfirmationService} confirmationService - This parameter is used to display confirmation
   * dialogs to the user. It is provided by the ConfirmationService class.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API calls.
   * @param {Router} router - The `router` parameter is used for routing and navigation in Angular. It
   * allows you to navigate to different components and pass data between them.
   * @param {ActivatedRoute} route - The `route` parameter is used to access the current route's
   * information, such as the URL parameters and query parameters. It is an instance of the
   * `ActivatedRoute` class, which is provided by the Angular Router.
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user-related functionalities such as login, logout, and user information.
   * @param {TovpilUtilsService} tovpilUtils - TovpilUtilsService is a service that provides utility
   * functions for the Tovpil application. It may include functions for formatting data, manipulating
   * strings, or performing common calculations.
   * @param {TovpilFilesService} filesService - TovpilFilesService is a service that handles file-related
   * operations such as uploading, downloading, and deleting files.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private markerService: MarkerService,
    private shapeService: ShapeService) {

    this.dataForm = this.fb.group({
      data_language: [null],
    });

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
        this.storeId = params.storeId;
      });

    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }

  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const bodyElement = document.getElementById('body-root');
    bodyElement.style.overflow = 'hidden';

    this.currentUser = this.authenticationService.currentUserValue;
    this.getLanguages();
    this.getSecurity();

  }

  ngAfterViewInit(): void {
    this.initializePoints();
    this.markerService.setPointsCircleData(this.points);
    this.shapeService.setShapesData().subscribe(states => {
      this.shape = states;
      this.initializeShapes();
    });
  }


  initializePoints(): void {
    this.points = L.map('map', {
      center: [39.8282, -98.5795],
      zoom: 3
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 3,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.points);
  }


  initializeShapes() {
    const shapeLayout = L.geoJSON(this.shape, {
      style: (feature) => ({
        weight: 3,
        opacity: 0.5,
        color: '#008f68',
        fillOpacity: 0.8,
        fillColor: '#6DB65B'
      }),
      onEachFeature: (feature, layout) => (
        layout.on({
          mouseover: (e) => (this.initializeHighlight(e)),
          mouseout: (e) => (this.resetHighlight(e)),
        })
      )
    });

    this.points.addLayer(shapeLayout);
  }

  initializeHighlight(e) {
    const layout = e.target;

    layout.setStyle({
      weight: 10,
      opacity: 1.0,
      color: '#DFA612',
      fillOpacity: 1.0,
      fillColor: '#FAE042'
    });
  }

  resetHighlight(e) {
    const layout = e.target;

    layout.setStyle({
      weight: 3,
      opacity: 0.5,
      color: '#008f68',
      fillOpacity: 0.8,
      fillColor: '#6DB65B'
    });
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and then performs additional actions based on the response.
   * @param {string} user - A string representing the username or user identifier.
   * @param {string} password - The `password` parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and then calls another function to get
   * translated labels.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();
          this.getLstDataByMenuOption(null);
        });
    } else {
      this.getTranslatedLabels();
    }
  }

  /**
   * The function "getLanguages" initializes an array of language objects with their labels and values.
   */
  getLanguages() {
    this.languagesLst = [
      { label: "Ingles", value: "en" },
      { label: "Español", value: "es" },
      { label: "Frances", value: "fr" },
    ]
  }

  /**
 * The function `getLstData()` fetches data using the `storeId` and `language` properties from the
 * `selectedSupplier` and `security` objects respectively.
 */
  getLstData(params) {
    this.fetch(params);
  }


  /**
   * The function lstSuppliersBySupStoreId retrieves a list of suppliers based on the store ID and
   * language, assigns the data to the listSuppliers variable, selects the first supplier in the list,
   * and then calls the loadPurchOrdSup function.
   */
  getLstDataByMenuOption(paramsToSet: any) {
    this.setDefaultValues(paramsToSet || {
      'language': { label: "Español", value: this.security.language },
    });
    const jsonUpdate = this.parsingValues(this.dataForm.value)
    this.getLstData({
      "storeId": '0000000002',
      "langauge": jsonUpdate['language'].value
    });
  }


  /**
   * The `loadData` function checks if the `dataForm` is valid, and if so, it calls the
   * `getLstDataByMenuOption` function with the selected language. If the form is not valid, it prevents
   * the default event behavior and displays an error message.
   * @param {Event} event - The event parameter is an object that contains the value of the selected
   * language.
   */
  loadData(event: Event) {
    if (this.dataForm.valid) {
      this.getLstDataByMenuOption({
        'language': event['value'],
      });
    } else {
      event.preventDefault();
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Datos Invalidos, Por favor ingreese los datos solicitados!',
        life: 5000
      });
    }
  }

  /**
   * The function `editData` is used to navigate to a specific page with some data and security
   * information.
   * @param {any} rowData - The `rowData` parameter is of type `any` and represents the data of a row in
   * a table or grid. It is used to pass the data of the selected row to the `editData` function for
   * further processing or editing.
   */
  editData(rowData: any) {
    console.debug("Editando", rowData);
    try {
      let navigationExtras: NavigationExtras = {
        state: JSON.parse(JSON.stringify({
          orderId: '0000000063',
          security: this.security
        }))
      };

      try {
        this.router.navigate(['materials/localNationalOrderDtl'], navigationExtras);
      } catch (navigationError) {
        console.error("An error occurred while navigating to coordination catalog details:", navigationError);
        this.messageService.add({ severity: 'error', summary: 'Error de navegación', detail: 'Hubo un problema al navegar a los detalles del catálogo de coordinación', life: 5000 });
      }
    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Hubo un problema al procesar los datos del catálogo de coordinación', life: 5000 });
    }
  }

  /**
   * The fetch function makes an API call to retrieve purchase order data, handles the success and error
   * cases, and sets a blocked flag to prevent further actions while the API call is in progress.
   * @param {any} requestParams - The `requestParams` parameter is an object that contains the parameters
   * to be sent with the fetch request. These parameters could include things like query strings,
   * headers, or body data. The specific structure and content of the `requestParams` object would depend
   * on the requirements of the API being called.
   */
  fetch(requestParams: any) {
    this.blocked = true;
    this.tovpilCrudService.fetch(this.endPointFindPurchordhByStoreId, requestParams).then(result => {
      if (result.success) {
        this.handleSuccess(result.data);
      } else {
        console.error("An error occurred while fetching purchase order data:");
        this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }
    }).finally(() => {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    });
  }

  /**
   * The handleSuccess function handles the successful response from an API call by extracting columns
   * from the JSON data, assigning the data to an array, and calculating the number of rows per page.
   * @param {any[]} data - The `data` parameter is an array of objects. Each object represents a row of
   * data in a table.
   */
  handleSuccess(data: any[]) {
    if (data.length > 0) {
      // Extraer dinámicamente las columnas del JSON
      this.cols = this.tovpilCrudService.extractColumns(data[0], undefined, this.colsFilter);
      // Asignar los datos al arreglo de productos
      this.data = data;
      // Asignar el número de filas por página dinámicamente
      this.rowsPerPage = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsPerPage);
    } else {
      this.data = null;
      this.cols = null;
      this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
    //console.debug(this.data);
    //console.debug(this.cols);
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  handleError(message: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
   * The function "capitalizeLastElement" takes a string as input and returns the same string with the
   * last element capitalized.
   * @param {string} str - The parameter `str` is a string that represents the input string.
   * @returns the result of calling the `capitalizeLastElement` method of the `tovpilCrudService` object
   * with the `str` parameter.
   */
  capitalizeLastElement(str: string): string {
    return this.tovpilCrudService.capitalizeLastElement(str);
  }

  /**
   * The function `getNestedValue` retrieves a nested value from an object using a specified field.
   * @param {any} obj - The `obj` parameter is an object from which you want to retrieve a nested value.
   * @param {string} field - The `field` parameter is a string that represents the path to a nested value
   * in the `obj` object.
   * @returns The `getNestedValue` function is returning the value of the nested field in the given
   * object.
   */
  getNestedValue(obj: any, field: string): any {
    return this.tovpilCrudService.getNestedValue(obj, field);
  }

  /**
   * The `exportExcel()` function exports data to an Excel file if the data is not null and not empty,
   * otherwise it displays an error message.
   */
  exportExcel() {
    if (this.data === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.data.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.data.map((item) => {
        const dynamicColumns = this.colsFilter.map((col) => ({
          [col.name]: item ? this.tovpilCrudService.getNestedValue(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      this.filesService.tovpilExportXLSX(filteredJSON, 'listPurchOrdSup_');
    }
  }

  /**
   * The `exportPdf()` function exports data to a PDF file if the data is not null and the list is not
   * empty, otherwise it displays an error message.
   */
  exportPdf() {
    if (this.data === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.data.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.data.map((item) => {
        const dynamicColumns = this.colsFilter.map((col) => ({
          [col.name]: item ? this.tovpilCrudService.getNestedValue(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));
      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listPurchOrders_');
    }
  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    window.close();
  }

  /**
   * The function `getTranslatedLabels` retrieves translated labels from an API and assigns them to
   * corresponding variables.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_language, this.lbl_schedule, this.lbl_participants, this.lbl_new_record, this.lbl_name, this.lbl_cell_phone, this.lbl_email, this.lbl_gender, this.lbl_edit, this.lbl_delete, this.lbl_search, this.lbl_particp15s, this.lbl_participants_12, this.lbl_participants_1st, this.lbl_future_guide, this.lbl_partic_partner, this.lbl_no_sent, this.lbl_age, this.lbl_workshop, this.lbl_school_prep_guides, this.lbl_comments, this.lbl_date, this.lbl_save, this.lbl_guide_id, this.lbl_certificate, this.lbl_change_Status_Guide_or_Comment, this.lbl_coordination, this.lbl_guideId, this.lbl_status, this.lbl_leaving_reason, this.lbl_select, this.lbl_send, this.lbl_guide, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_updated_data, this.lbl_delete_record, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_total, this.lbl_vendor, this.lbl_OR_vendor_quote, this.lbl_new, this.lbl_orders_request, this.lbl_req_Date, this.lbl_currency]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_language = map.get(this.lbl_language);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_particp15s = map.get(this.lbl_particp15s);
        this.lbl_participants_12 = map.get(this.lbl_participants_12);
        this.lbl_participants_1st = map.get(this.lbl_participants_1st);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_partic_partner = map.get(this.lbl_partic_partner);
        this.lbl_no_sent = map.get(this.lbl_no_sent);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_school_prep_guides = map.get(this.lbl_school_prep_guides);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_date = map.get(this.lbl_date);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_change_Status_Guide_or_Comment = map.get(this.lbl_change_Status_Guide_or_Comment);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_leaving_reason = map.get(this.lbl_leaving_reason);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_vendor = map.get(this.lbl_vendor);
        this.lbl_OR_vendor_quote = map.get(this.lbl_OR_vendor_quote);
        this.lbl_new = map.get(this.lbl_new);
        this.lbl_orders_request = map.get(this.lbl_orders_request);
        this.lbl_req_Date = map.get(this.lbl_req_Date);
        this.lbl_currency = map.get(this.lbl_currency);
      });
  }

  /**
   * The function sets the default value for the "data_language" field in a form using the value provided
   * in the "language" parameter.
   * @param {any} params - An object containing the parameters for setting default values.
   */
  setDefaultValues(params: any) {
    this.dataForm.patchValue({
      data_language: params['language']
    });
  }

  /**
   * The function "parsingValues" parses form values and returns an object with a "language" property.
   * @param {any} formValues - The `formValues` parameter is an object that contains the values submitted
   * from a form.
   * @returns an object with a key "language" and a value that is either the value of
   * formValues['data_language'] if it is not null, or null if it is null.
   */
  parsingValues(formValues: any) {
    return {
      "language": formValues['data_language'] == null ? null : formValues['data_language'],
    }
  }
}
